{
  "scheduling": "예약 관리",
  "date": "날짜",
  "time": "시간",
  "duration": "소요 시간",
  "provider": "담당의",
  "reason": "진료 사유",
  "status": "상태",
  "statusOptions": {
    "scheduled": "예약됨",
    "confirmed": "확인됨",
    "arrived": "도착",
    "checked-in": "접수 완료",
    "in-progress": "진행 중",
    "completed": "완료",
    "cancelled": "취소됨",
    "no-show": "미내원"
  },
  "coverageScope": {
    "panel": "환자 패널",
    "unit": "병동",
    "facility": "전체 시설"
  },
  "coverageScopeDescription": {
    "panel": "대상 의료진의 환자 패널만 해당합니다.",
    "unit": "대상 의료진의 배정 병동.",
    "facility": "전체 시설 — 일반적으로 온콜 체제."
  },
  "dayShort": {
    "0": "일",
    "1": "월",
    "2": "화",
    "3": "수",
    "4": "목",
    "5": "금",
    "6": "토"
  },
  "blockType": {
    "available": "예약 가능",
    "blocked": "차단됨"
  },
  "appointmentTypes": {
    "followUp": "재진",
    "newPatient": "신환",
    "consultation": "상담",
    "procedure": "처치",
    "urgent": "응급",
    "wellnessCheck": "건강 검진",
    "physical": "신체 검사",
    "telemedicine": "원격 진료",
    "scheduleTemplate": "일정 템플릿"
  },
  "pages": {
    "providerDirectory": {
      "title": "의료진 디렉터리",
      "subtitle": "의료진 검색 및 조회",
      "search": {
        "namePlaceholder": "이름으로 검색...",
        "specialtyPlaceholder": "전문 분야로 검색..."
      },
      "filters": {
        "facilityAriaLabel": "기관별 필터",
        "departmentAriaLabel": "부서별 필터",
        "allFacilities": "모든 기관",
        "allDepartments": "모든 부서"
      },
      "loading": "의료진 정보를 불러오는 중...",
      "loadError": "의료진 디렉터리를 불러오지 못했습니다.",
      "empty": "조건에 맞는 의료진을 찾을 수 없습니다.",
      "npiLabel": "NPI:"
    },
    "scheduleTemplateForm": {
      "title": "스케줄 템플릿 만들기",
      "labels": {
        "provider": "의료진",
        "dayOfWeek": "요일",
        "startTime": "시작 시간",
        "endTime": "종료 시간",
        "slotDuration": "슬롯 길이(분)",
        "templateName": "템플릿 이름",
        "effectiveStartDate": "유효 시작일"
      },
      "slotDurationOption": "{{minutes}}분",
      "buttons": {
        "cancel": "취소",
        "save": "템플릿 저장"
      },
      "toast": {
        "success": "스케줄 템플릿이 저장되었습니다",
        "failure": "스케줄 템플릿 저장에 실패했습니다"
      },
      "placeholders": {
        "templateName": "예: 월요일 오전 진료"
      },
      "defaultName": "{{day}} 일정"
    },
    "scheduleManagement": {
      "title": "스케줄 관리",
      "backToDashboard": "← 대시보드",
      "newTemplate": "새 템플릿",
      "today": "오늘",
      "blockTooltip": "{{start}} - {{end}} ({{state}})",
      "slotsLabel": "{{minutes}}분 슬롯",
      "legend": {
        "booked": "예약됨"
      },
      "upcomingAppointmentsHeading": "다가오는 예약 - {{providerName}}",
      "loadingAppointments": "예약을 불러오는 중...",
      "unknownPatient": "알 수 없는 환자",
      "fallbackAppointmentType": "일반",
      "noUpcomingAppointments": "이 의료진의 다가오는 예약이 없습니다"
    },
    "providerCoverage": {
      "title": "의료진 대진",
      "subtitle": "기간 제한 근무 대진 — 정해진 기간 동안 동료에게 환자 패널을 인계합니다. 긴급 접근(브레이크-글래스)과는 다르며, 휴가·온콜 순환·예정된 부재에 사용합니다.",
      "actions": {
        "newCoverage": "새 대진",
        "cancel": "취소"
      },
      "form": {
        "title": "새 대진 등록",
        "labels": {
          "coveredProviderId": "대진 대상 의료진",
          "coveringProviderId": "대진 담당 의료진",
          "scope": "범위",
          "from": "시작",
          "until": "종료",
          "reason": "사유"
        },
        "placeholders": {
          "coveredProviderId": "패널이 인계되는 의료진",
          "coveringProviderId": "해당 기간을 맡을 의료진",
          "reason": "예: 4월 22–29일 연차; 주말 온콜 대진"
        },
        "help": {
          "coveredProviderId": "COVERAGE_ADMIN 권한이 없으면 본인을 선택해야 합니다.",
          "coveringProviderId": "이름으로 검색해 선택하세요 — 입력한 ID에는 대진을 부여하지 않습니다."
        },
        "aria": {
          "effectiveFromDate": "시작 날짜",
          "effectiveFromTime": "시작 시간",
          "effectiveUntilDate": "종료 날짜",
          "effectiveUntilTime": "종료 시간"
        },
        "buttons": {
          "cancel": "취소",
          "create": "대진 생성"
        },
        "typeaheadEmpty": "담당의를 찾을 수 없습니다"
      },
      "sections": {
        "mine": {
          "title": "내 대진",
          "subtitle": "제가 대진 담당이거나 대진 대상인 항목입니다.",
          "empty": "등록된 대진이 없습니다."
        },
        "all": {
          "title": "모든 대진",
          "subtitle": "조직 내 모든 대진 배치. 관리자 보기.",
          "empty": "어디에도 대진이 없습니다. 좋은 소식이거나 필터가 오래되었습니다."
        }
      },
      "list": {
        "coveringConnector": "대진 중",
        "groups": {
          "active": "활성 ({{count}})",
          "planned": "예정 / 과거 ({{count}})",
          "revoked": "취소됨 ({{count}})"
        },
        "untilRevoked": "취소까지",
        "revokedPrefix": "취소",
        "revokeTitle": "취소"
      },
      "revokeDialog": {
        "title": "대진을 취소하시겠습니까?",
        "description": "{{coveringProviderName}}이(가) 더 이상 {{coveredProviderName}}을(를) 대진하지 않습니다. 기록은 감사 로그에 남습니다.",
        "confirm": "취소",
        "reasonPlaceholder": "이 대진을 종료하는 이유 (선택 사항)"
      },
      "toast": {
        "created": "대진을 등록했습니다",
        "revoked": "대진을 취소했습니다",
        "invalid": "유효하지 않은 대진 — 의료진과 날짜를 확인하세요",
        "forbidden": "이 의료진에 대한 대진을 생성할 권한이 없습니다",
        "createFailed": "대진 등록에 실패했습니다",
        "revokeFailed": "대진 취소에 실패했습니다"
      }
    },
    "appointments": {
      "title": "예약",
      "subtitle": "환자 예약 일정 관리",
      "actions": {
        "refresh": "새로고침",
        "schedule": "예약 잡기",
        "arriveTitle": "도착 기록",
        "arriveAria": "{{patientName}} 도착 기록",
        "checkInTitle": "접수",
        "checkInAria": "{{patientName}} 접수",
        "rescheduleTitle": "일정 변경",
        "rescheduleAria": "{{patientName}} 일정 변경",
        "cancelTitle": "취소",
        "cancelAria": "{{patientName}} 예약 취소",
        "checkedInLabel": "접수 완료",
        "startVisitTitle": "진료 시작",
        "startVisitAria": "{{patientName}} 진료 시작"
      },
      "weekNav": {
        "previous": "이전 주",
        "previousAria": "이전 주",
        "next": "다음 주",
        "nextAria": "다음 주"
      },
      "calendar": {
        "gridAria": "주간 예약 캘린더",
        "timeColumn": "시간",
        "loading": "일정을 불러오는 중...",
        "cellAria": "{{dayLabel}} {{date}} {{time}}",
        "cellTitle": "{{patientName}} - {{appointmentType}} ({{status}})"
      },
      "upcoming": {
        "heading": "다가오는 예약",
        "empty": "이번 주 예약이 없습니다",
        "durationMinutes": "{{minutes}}분",
        "columns": {
          "dateTime": "날짜 / 시간",
          "patient": "환자",
          "type": "유형",
          "provider": "담당의",
          "duration": "소요 시간",
          "status": "상태",
          "actions": "작업"
        }
      },
      "toast": {
        "cancelled": "예약이 취소되었습니다",
        "cancelFailed": "예약 취소에 실패했습니다",
        "visitStarted": "진료가 시작되었습니다",
        "startVisitFailed": "진료를 시작하지 못했습니다",
        "arrivalRecorded": "도착이 기록되었습니다",
        "arrivalFailed": "도착을 기록하지 못했습니다"
      }
    },
    "appointmentForm": {
      "title": {
        "create": "신규 예약",
        "edit": "예약 변경"
      },
      "labels": {
        "patient": "환자",
        "appointmentType": "예약 유형",
        "provider": "담당의",
        "scheduledAt": "예약 일시",
        "duration": "소요 시간",
        "reason": "진료 사유"
      },
      "placeholders": {
        "patientSearch": "이름 또는 MRN으로 환자 검색...",
        "provider": "담당의 이름",
        "reason": "진료 사유를 간단히..."
      },
      "patientTypeahead": {
        "empty": "환자를 찾을 수 없습니다"
      },
      "aria": {
        "appointmentDate": "예약 날짜",
        "appointmentTime": "예약 시간"
      },
      "durationOption": "{{minutes}}분",
      "buttons": {
        "cancel": "취소",
        "schedule": "예약하기",
        "update": "예약 업데이트"
      },
      "toast": {
        "created": "예약이 생성되었습니다",
        "updated": "예약이 업데이트되었습니다",
        "createFailed": "예약 생성에 실패했습니다",
        "updateFailed": "예약 업데이트에 실패했습니다"
      },
      "validation": {
        "patientRequired": "환자를 선택해 주세요",
        "appointmentTypeRequired": "예약 유형은 필수입니다",
        "scheduledAtRequired": "날짜와 시간을 입력해 주세요",
        "durationInvalid": "소요 시간은 1~480분 사이여야 합니다",
        "providerRequired": "담당의를 선택해 주세요"
      },
      "providerTypeahead": {
        "empty": "담당의를 찾을 수 없습니다"
      },
      "loadingEdit": "예약을 불러오는 중…",
      "loadEditError": "이 예약을 불러올 수 없습니다.",
      "patientLocked": "일정 변경 시 환자를 바꿀 수 없습니다."
    },
    "waitlist": {
      "title": "예약 대기 명단",
      "backToDashboard": "← 대시보드",
      "entryCount": "{{count}}건",
      "searchPlaceholder": "환자 이름, MRN 또는 메모 검색...",
      "clearSearchAria": "검색 지우기",
      "filters": {
        "allProviders": "모든 의료진",
        "allTypes": "모든 유형",
        "providerAriaLabel": "의료진별 필터",
        "typeAriaLabel": "예약 유형별 필터"
      },
      "columns": {
        "patient": "환자",
        "provider": "의료진",
        "type": "유형",
        "priority": "우선순위",
        "requestedDates": "요청 날짜",
        "dateAdded": "등록일",
        "notes": "메모",
        "actions": "작업",
        "reason": "사유"
      },
      "priority": {
        "urgent": "긴급",
        "routine": "일반",
        "flexible": "유연"
      },
      "actions": {
        "scheduleTitle": "예약 잡기",
        "editPriorityTitle": "우선순위 편집",
        "removeTitle": "대기 명단에서 제거"
      },
      "empty": "필터 조건과 일치하는 대기 명단 항목이 없습니다",
      "loadFailed": "대기 명단을 불러오지 못했습니다. 연결을 확인하고 다시 시도하세요.",
      "modal": {
        "title": "예약 잡기",
        "closeAria": "닫기",
        "providerLabel": "의료진:",
        "requestedLabel": "요청:",
        "dateTimeLabel": "예약 날짜 및 시간 *",
        "dateAria": "예약 날짜",
        "timeAria": "예약 시간",
        "requestedWindow": "요청 기간: {{start}} — {{end}}",
        "cancel": "취소",
        "submit": "예약"
      },
      "toasts": {
        "removed": "대기 명단에서 제거되었습니다",
        "priorityUpdated": "우선순위가 업데이트되었습니다",
        "scheduled": "예약이 잡혔으며 대기 명단에서 제거되었습니다",
        "dateTimeRequired": "날짜와 시간을 선택하세요",
        "updateFailed": "대기자 명단 업데이트에 실패했습니다",
        "promoteOrphaned": "예약은 생성되었지만 대기자 명단 항목을 업데이트하지 못했습니다. 다시 시도하기 전에 일정을 확인하세요."
      }
    },
    "checkIn": {
      "title": "환자 접수",
      "subtitle": "접수 — 보험, 승인, 본인부담금. 환자는 이미 도착했습니다.",
      "fields": {
        "insuranceId": "보험",
        "copayAmount": "본인부담금 금액",
        "copayCollected": "본인부담금 수납",
        "authorizationNumber": "승인 번호",
        "authorizationVerified": "승인 확인됨"
      },
      "copayHint": "본인부담금 수납으로 표시하면 환자 계정에 결제가 기록됩니다.",
      "submit": "접수 완료",
      "cancel": "취소",
      "toast": {
        "success": "환자가 접수되었습니다",
        "failed": "환자를 접수하지 못했습니다"
      }
    },
    "providerTypeahead": {
      "loadError": "의료진 디렉터리를 사용할 수 없습니다 — 연결을 확인하고 다시 시도하세요.",
      "retry": "다시 시도"
    }
  }
}
